// angular.module('HeroPRO')
// .directive('dropdownSmallPopup',

import angular from 'angular';
import './dropdown.scss';

/* @ngInject */
export default function DropdownSmallPopupDirective($window, $document, HPConfig) {
    return {
        restrict: 'A',
        scope: { dropdownTitle: '@' },
        link(scope, element) {
            const dropdown = angular.element(element[0].querySelector('.dropdown-menu'));
            const dropdownToggle = angular.element(element[0].querySelector('.dropdown-toggle'));

            if (element[0].querySelector('.dropdown-menu') !== null && dropdown[0].localName === 'ul') {
                const ddTitle = scope.dropdownTitle || '&nbsp;';
                dropdown.prepend(`<li class='close-icon'>${ddTitle}<span class='icon icon-delete-circle'></span></li>`);
            } else {
                dropdown.prepend("<div class='close-icon'><span class='icon icon-delete-circle'></span></div>");
            }
            dropdown.bind('click', () => {
                if ($window.innerWidth < HPConfig.screenSizes.screen_md) {
                    angular.element($document[0].body).removeClass('fixed-body');
                    $window.scroll(scope.scrollX, scope.scrollY);
                }
            });
            dropdownToggle.bind('click', () => {
                const userDropdown = $window.document.querySelector('.dropdown-menu-user-info');
                const contactDropdown = $window.document.querySelector('.dropdown-menu-contact-info');

                if ($window.innerWidth < HPConfig.screenSizes.screen_md) {
                    scope.scrollX = $window.pageXOffset;
                    scope.scrollY = $window.pageYOffset;
                    angular.element($document[0].body).addClass('fixed-body');
                } else if ($window.innerWidth !== $window.document.documentElement.clientWidth && userDropdown && contactDropdown) {
                    // HACK: If desktop and scrollbars are being shown explicitly set position of contact and user drodpown menus
                    userDropdown.style.right = '30px';
                    contactDropdown.style.right = '104px';
                }

                return true;
            });
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/dropdown/dropdownSmallPopupDirective.js